export const CREATE_RECIPIENT = 'CREATE_RECIPIENT'
export const GET_RECIPIENTS = 'GET_RECIPIENTS'
export const GET_RECIPIENT_BY_ID = 'GET_RECIPIENT_BY_ID'
export const CLEAR_RECIPIENT = 'CLEAR_RECIPIENT'
